<div class="popup salesperson searching-result" [ngClass]="show ? 'opened' : ''"
  (click)="handleOnClickPopupContainer($event);">
  <div class="container default-container popup-content">
    <div class="popup-header row">
      <h2 class="col h-medium">Shipping Method</h2>
      <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
        <svg width="22" height="22" viewBox="0 0 22 22">
          <path d="M1 1L21 21" />
          <path d="M21 1L1 21" />
        </svg>
      </a>
    </div>
    <div class="popup-body">
      <div class="container default-container results">
        <p>To avoid any shipping disputes regarding lost, stolen, and/or missing packages</p>
        <p>we strongly recommend that you choose</p>
        <p>the UPS Signature Service shipping option during checkout.</p>
        <p>MEDIUS is not responsible for any packages</p>
        <p>that are lost, stolen, or missing during transit.</p>
        <p>If you need further assistance due to a shipping discrepancy,</p>
        <p>please contact us via the 1:1 Inquiries Board on our Website,</p>
        <p>(include your name and relevant information along with a brief description),</p>
        <p>and we will do our best to accommodate you.</p>
        <div class="row">
          <a class="w-btn small-btn col light-btn" (click)="handleOnClickUPSOption(UPS)">UPS</a>
          <a class="w-btn small-btn col primary-btn" (click)="handleOnClickUPSOption(UPSSignature)">UPS Signature (+$2.00)</a>
        </div>
      </div>
    </div>
  </div>
</div>